export const LAT_MINIMUM = -90;
export const LAT_MAXIMUM = 90;
export const LON_MINIMUM = -180;
export const LON_MAXIMUM = 180;

export const GEO_LOCATION_STEP = 0.00001;
